import { fitContentWidth } from '../../utils';
import { BLACK, BLACK_100, BLACK_200, BLACK_300, BLACK_400, BLACK_500, BLACK_700, BLACK_800, BLACK_900, BLUE_400, BLUE_500, BLUE_600, BLUE_GREY_100, BLUE_GREY_200, BLUE_GREY_400, BLUE_GREY_600, BLUE_GREY_700, BLUE_GREY_800, BLUE_GREY_900, BLACK_600, LILAC_300, LILAC_400, LILAC_700, RED_500, RED_600, RED_700, TRANSPARENT, WHITE } from '../colors';
var alternateLight = {
  size: {
    sm: {
      paddingHorizontal: 'SPACING_8',
      height: 26
    },
    md: {
      paddingHorizontal: 'SPACING_10',
      height: 28
    },
    lg: {
      paddingHorizontal: 'SPACING_12',
      height: 30
    }
  },
  version: {
    'fixed-padding': fitContentWidth(),
    'variable-width': {
      width: '100%'
    }
  },
  iconPosition: {
    left: {
      flexDirection: 'row',
      marginRight: 'SPACING_4'
    },
    right: {
      flexDirection: 'row-reverse',
      marginLeft: 'SPACING_4'
    }
  },
  controlState: {
    none: {
      buttonColor: TRANSPARENT,
      textColor: WHITE,
      borderWidth: 1,
      borderColor: WHITE,
      borderRadius: 'BORDER_RADIUS_16'
    },
    disabled: {
      buttonColor: TRANSPARENT,
      textColor: BLACK_500,
      borderWidth: 1,
      borderColor: BLACK_500,
      borderRadius: 'BORDER_RADIUS_16'
    },
    hover: {
      buttonColor: BLACK_700,
      textColor: WHITE,
      borderWidth: 1,
      borderRadius: 'BORDER_RADIUS_16',
      borderColor: WHITE
    },
    pressed: {
      buttonColor: TRANSPARENT,
      textColor: BLACK_300,
      borderWidth: 1,
      borderRadius: 'BORDER_RADIUS_16',
      borderColor: BLACK_300
    },
    selected: {
      buttonColor: TRANSPARENT,
      textColor: WHITE,
      borderWidth: 1,
      borderColor: WHITE,
      borderRadius: 'BORDER_RADIUS_16'
    }
  }
};
var alternateDark = {
  size: {
    sm: {
      paddingHorizontal: 'SPACING_8',
      height: 26
    },
    md: {
      paddingHorizontal: 'SPACING_10',
      height: 28
    },
    lg: {
      paddingHorizontal: 'SPACING_12',
      height: 30
    }
  },
  version: {
    'fixed-padding': fitContentWidth(),
    'variable-width': {
      width: '100%'
    }
  },
  iconPosition: {
    left: {
      flexDirection: 'row',
      marginRight: 'SPACING_4'
    },
    right: {
      flexDirection: 'row-reverse',
      marginLeft: 'SPACING_4'
    }
  },
  controlState: {
    none: {
      buttonColor: TRANSPARENT,
      textColor: BLACK,
      borderRadius: 'BORDER_RADIUS_16',
      borderWidth: 1,
      borderColor: BLACK
    },
    disabled: {
      buttonColor: TRANSPARENT,
      textColor: BLACK_500,
      borderRadius: 'BORDER_RADIUS_16',
      borderWidth: 1,
      borderColor: BLACK_500
    },
    hover: {
      buttonColor: BLACK_800,
      textColor: WHITE,
      borderRadius: 'BORDER_RADIUS_16'
    },
    pressed: {
      buttonColor: TRANSPARENT,
      textColor: BLACK_700,
      borderRadius: 'BORDER_RADIUS_16',
      borderWidth: 1,
      borderColor: BLACK_700
    },
    selected: {
      buttonColor: TRANSPARENT,
      textColor: BLACK,
      borderRadius: 'BORDER_RADIUS_16',
      borderWidth: 1,
      borderColor: BLACK
    }
  }
};
var lightTheme = {
  theme: 'light',
  buttonType: 'primary',
  size: 'sm',
  iconPosition: 'left',
  loaderPosition: 'right',
  version: 'fixed-padding',
  controlState: 'none',
  disabled: false,
  isUpperCase: false,
  isSelected: false,
  style: {},
  iconName: '',
  showLoader: false,
  config: {
    primary: {
      size: {
        sm: {
          paddingHorizontal: 'SPACING_12',
          height: 40
        },
        md: {
          paddingHorizontal: 'SPACING_12',
          height: 48
        },
        lg: {
          paddingHorizontal: 'SPACING_12',
          height: 56
        }
      },
      version: {
        'fixed-padding': Object.assign({
          minWidth: 112
        }, fitContentWidth()),
        'variable-width': {
          width: '100%'
        }
      },
      iconPosition: {
        left: {
          flexDirection: 'row',
          marginRight: 'SPACING_4'
        },
        right: {
          flexDirection: 'row-reverse',
          marginLeft: 'SPACING_4'
        }
      },
      controlState: {
        none: {
          buttonColor: BLACK,
          textColor: BLACK_100,
          borderRadius: 'BORDER_RADIUS_8'
        },
        disabled: {
          buttonColor: BLACK_500,
          textColor: BLACK_700,
          borderRadius: 'BORDER_RADIUS_8'
        },
        hover: {
          buttonColor: BLACK_800,
          textColor: BLACK_100,
          borderWidth: 1,
          borderRadius: 'BORDER_RADIUS_8',
          borderColor: BLACK
        },
        pressed: {
          buttonColor: BLACK_900,
          textColor: BLACK_100,
          borderRadius: 'BORDER_RADIUS_8'
        },
        selected: {
          buttonColor: BLUE_500,
          textColor: BLACK_100,
          borderRadius: 'BORDER_RADIUS_8',
          borderColor: BLUE_500
        }
      }
    },
    secondary: {
      size: {
        sm: {
          paddingHorizontal: 'SPACING_12',
          height: 40
        },
        md: {
          paddingHorizontal: 'SPACING_12',
          height: 48
        },
        lg: {
          paddingHorizontal: 'SPACING_12',
          height: 56
        }
      },
      version: {
        'fixed-padding': Object.assign({
          minWidth: 112
        }, fitContentWidth()),
        'variable-width': {
          width: '100%'
        }
      },
      iconPosition: {
        left: {
          flexDirection: 'row',
          marginRight: 'SPACING_4'
        },
        right: {
          flexDirection: 'row-reverse',
          marginLeft: 'SPACING_4'
        }
      },
      controlState: {
        none: {
          buttonColor: LILAC_400,
          textColor: BLACK_900,
          borderRadius: 'BORDER_RADIUS_8'
        },
        disabled: {
          buttonColor: LILAC_300,
          textColor: LILAC_700,
          borderRadius: 'BORDER_RADIUS_8'
        },
        hover: {
          buttonColor: LILAC_300,
          textColor: BLACK_900,
          borderWidth: 1,
          borderRadius: 'BORDER_RADIUS_8',
          borderColor: LILAC_700
        },
        pressed: {
          buttonColor: LILAC_300,
          textColor: BLACK_900,
          borderRadius: 'BORDER_RADIUS_8'
        },
        selected: {
          buttonColor: BLUE_500,
          textColor: BLACK_100,
          borderRadius: 'BORDER_RADIUS_8',
          borderColor: BLUE_500
        }
      }
    },
    tertiary: {
      version: {
        'fixed-padding': fitContentWidth(),
        'variable-width': {
          width: '100%'
        }
      },
      iconPosition: {
        left: {
          flexDirection: 'row',
          marginRight: 'SPACING_4'
        },
        right: {
          flexDirection: 'row-reverse',
          marginLeft: 'SPACING_4'
        }
      },
      controlState: {
        none: {
          buttonColor: TRANSPARENT,
          textColor: BLUE_500
        },
        disabled: {
          buttonColor: TRANSPARENT,
          textColor: BLACK_500
        },
        hover: {
          buttonColor: TRANSPARENT,
          textColor: BLUE_400
        },
        pressed: {
          buttonColor: TRANSPARENT,
          textColor: BLUE_600,
          borderRadius: 'BORDER_RADIUS_8'
        },
        selected: {
          buttonColor: TRANSPARENT,
          textColor: BLUE_500
        }
      }
    },
    alternate: alternateLight,
    'alternate-light': alternateLight,
    'alternate-dark': alternateDark
  }
};
var darkTheme = Object.assign(Object.assign({}, lightTheme), {
  theme: 'dark',
  config: Object.assign(Object.assign({}, lightTheme.config), {
    primary: Object.assign(Object.assign({}, lightTheme.config.primary), {
      controlState: {
        none: {
          buttonColor: WHITE,
          textColor: BLACK_900,
          borderRadius: 'BORDER_RADIUS_8'
        },
        disabled: {
          buttonColor: WHITE,
          textColor: BLACK_400,
          borderRadius: 'BORDER_RADIUS_8'
        },
        hover: {
          buttonColor: BLACK_200,
          textColor: BLACK_900,
          borderWidth: 1,
          borderRadius: 'BORDER_RADIUS_8',
          borderColor: BLACK_400
        },
        pressed: {
          buttonColor: WHITE,
          textColor: BLACK_900,
          borderRadius: 'BORDER_RADIUS_8'
        },
        selected: {
          buttonColor: BLUE_500,
          textColor: BLACK_100,
          borderRadius: 'BORDER_RADIUS_8',
          borderColor: BLUE_500
        }
      }
    }),
    alternate: alternateDark
  })
});
var whiteTheme = Object.assign(Object.assign({}, lightTheme), {
  theme: 'white',
  config: Object.assign(Object.assign({}, lightTheme.config), {
    primary: Object.assign(Object.assign({}, lightTheme.config.primary), {
      controlState: {
        none: {
          buttonColor: RED_500,
          textColor: WHITE,
          borderRadius: 'BORDER_RADIUS_8'
        },
        disabled: {
          buttonColor: BLUE_GREY_200,
          textColor: BLUE_GREY_400,
          borderRadius: 'BORDER_RADIUS_8'
        },
        hover: {
          buttonColor: RED_600,
          textColor: WHITE,
          borderWidth: 1,
          borderColor: RED_500,
          borderRadius: 'BORDER_RADIUS_8'
        },
        pressed: {
          buttonColor: RED_700,
          textColor: WHITE,
          borderRadius: 'BORDER_RADIUS_8'
        },
        selected: {
          buttonColor: RED_600,
          textColor: WHITE,
          borderRadius: 'BORDER_RADIUS_8'
        }
      }
    }),
    secondary: Object.assign(Object.assign({}, lightTheme.config.secondary), {
      controlState: {
        none: {
          buttonColor: TRANSPARENT,
          textColor: BLUE_GREY_800,
          borderColor: BLUE_GREY_800,
          borderRadius: 'BORDER_RADIUS_8'
        },
        disabled: {
          buttonColor: BLUE_GREY_100,
          textColor: BLUE_GREY_400,
          borderColor: BLUE_GREY_400,
          borderRadius: 'BORDER_RADIUS_8'
        },
        hover: {
          buttonColor: BLUE_GREY_100,
          textColor: BLUE_GREY_800,
          borderWidth: 1,
          borderRadius: 'BORDER_RADIUS_8',
          borderColor: BLUE_GREY_800
        },
        pressed: {
          buttonColor: TRANSPARENT,
          textColor: BLUE_GREY_800,
          borderColor: BLUE_GREY_900,
          borderRadius: 'BORDER_RADIUS_8'
        },
        selected: {
          buttonColor: TRANSPARENT,
          textColor: BLUE_GREY_800,
          borderRadius: 'BORDER_RADIUS_8',
          borderColor: RED_700
        }
      }
    }),
    tertiary: Object.assign(Object.assign({}, lightTheme.config.tertiary), {
      controlState: {
        none: {
          buttonColor: TRANSPARENT,
          textColor: BLUE_500
        },
        disabled: {
          buttonColor: TRANSPARENT,
          textColor: BLACK_500
        },
        hover: {
          buttonColor: TRANSPARENT,
          textColor: BLUE_400
        },
        pressed: {
          buttonColor: TRANSPARENT,
          textColor: BLUE_600,
          borderRadius: 'BORDER_RADIUS_8'
        },
        selected: {
          buttonColor: TRANSPARENT,
          textColor: BLUE_500
        }
      }
    }),
    alternate: Object.assign(Object.assign({}, alternateLight), {
      controlState: {
        none: Object.assign(Object.assign({}, alternateLight.controlState.none), {
          borderRadius: 'BORDER_RADIUS_16'
        }),
        disabled: Object.assign(Object.assign({}, alternateLight.controlState.disabled), {
          textColor: BLACK_600,
          borderColor: BLACK_600,
          borderRadius: 'BORDER_RADIUS_16'
        }),
        hover: Object.assign(Object.assign({}, alternateLight.controlState.hover), {
          buttonColor: BLACK_700,
          borderRadius: 'BORDER_RADIUS_16'
        }),
        pressed: Object.assign(Object.assign({}, alternateLight.controlState.pressed), {
          textColor: BLACK_400,
          borderRadius: 'BORDER_RADIUS_16',
          borderColor: BLACK_400
        }),
        selected: Object.assign(Object.assign({}, alternateLight.controlState.selected), {
          textColor: BLACK_300,
          borderColor: BLACK_300,
          borderRadius: 'BORDER_RADIUS_16'
        })
      }
    }),
    'alternate-light': Object.assign(Object.assign({}, alternateLight), {
      controlState: {
        none: Object.assign(Object.assign({}, alternateLight.controlState.none), {
          borderRadius: 'BORDER_RADIUS_16'
        }),
        disabled: Object.assign(Object.assign({}, alternateLight.controlState.disabled), {
          textColor: BLACK_600,
          borderColor: BLACK_600,
          borderRadius: 'BORDER_RADIUS_16'
        }),
        hover: Object.assign(Object.assign({}, alternateLight.controlState.hover), {
          buttonColor: BLACK_700,
          borderRadius: 'BORDER_RADIUS_16'
        }),
        pressed: Object.assign(Object.assign({}, alternateLight.controlState.pressed), {
          textColor: BLACK_400,
          borderRadius: 'BORDER_RADIUS_16',
          borderColor: BLACK_400
        }),
        selected: Object.assign(Object.assign({}, alternateLight.controlState.selected), {
          textColor: BLACK_300,
          borderColor: BLACK_300,
          borderRadius: 'BORDER_RADIUS_16'
        })
      }
    }),
    'alternate-dark': Object.assign(Object.assign({}, alternateDark), {
      controlState: {
        none: Object.assign(Object.assign({}, alternateDark.controlState.none), {
          borderRadius: 'BORDER_RADIUS_16'
        }),
        disabled: Object.assign(Object.assign({}, alternateDark.controlState.disabled), {
          textColor: BLUE_GREY_400,
          borderRadius: 'BORDER_RADIUS_16',
          borderColor: BLUE_GREY_400
        }),
        hover: Object.assign(Object.assign({}, alternateDark.controlState.hover), {
          buttonColor: BLUE_GREY_800,
          borderColor: WHITE,
          borderRadius: 'BORDER_RADIUS_16'
        }),
        pressed: Object.assign(Object.assign({}, alternateDark.controlState.pressed), {
          textColor: BLUE_GREY_600,
          borderRadius: 'BORDER_RADIUS_16',
          borderColor: BLUE_GREY_600
        }),
        selected: Object.assign(Object.assign({}, alternateDark.controlState.selected), {
          textColor: BLUE_GREY_700,
          borderRadius: 'BORDER_RADIUS_16',
          borderColor: BLUE_GREY_700
        })
      }
    })
  })
});
export default {
  light: lightTheme,
  dark: darkTheme,
  white: whiteTheme
};